import { getLabelFromOptionId } from './labelHelpers';
import { IDropdownOptions } from '@shared/interface';

// Re-export date utilities from centralized location
export { formatDate, formatDateForAPI, parseDateFromAPI } from '@core/utils/dateUtils';

/**
 * Format file size in bytes to human readable format
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};

export const formatCurrency = (
  price: number,
  currency: number | null,
  currencyOptions: IDropdownOptions[],
  priceOptions?: IDropdownOptions[],
) => {
  const priceLabel = priceOptions ? getLabelFromOptionId(price, priceOptions) : price.toLocaleString();
  if (!currency) return `$${priceLabel}`;
  const currencyLabel = getLabelFromOptionId(currency, currencyOptions);
  return `${priceLabel} ${currencyLabel}`;
};
